<template>
    <div id="page-container">
        <main-sidebar :class="{ 'active': isMainSidebarOpen }"></main-sidebar>
        <div id="page-content-container" :class="{ 'sidebar-open': isMainSidebarOpen }">
            <main-header></main-header>
            <div id="page-content">
                <slot v-if="status === 'ready'"></slot>
                <qw-chatbot :class="{ 'tasks-open': isTasksSidebarOpen }"></qw-chatbot>
                <tasks-sidebar :class="{ 'tasks-open': isTasksSidebarOpen }"></tasks-sidebar>
            </div>
        </div>
    </div>
</template>

<script>
import MainSidebar from "@/components/MainSidebar";
import MainHeader from "@/components/MainHeader";
import TasksSidebar from "@/components/TasksSidebar";
import QwChatbot from "@/components/chatbot/QWChatbot";
import ApplicationService from "../services/ApplicationService";

export default {
    name: "page-container",
    components: {
        MainSidebar,
        MainHeader,
        TasksSidebar,
        QwChatbot
    },
    data() {
        return {
            status: "ready"
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init(){
            this.status = "loading";
            ApplicationService.getRecentAndMostViewedApplications()
                .then(response => {
                    localStorage.setItem('UserPreferences', JSON.stringify(response.data));
                    this.status = "ready";
                }).catch(error => console.log(error));
        }
    },
    computed: {
        isMainSidebarOpen() {
            return this.$store.getters['mainSidebar/isMainSidebarOpen'];
        },
        isTasksSidebarOpen() {
            return this.$store.getters.isTasksSidebarOpen;
        }
    }
}
</script>
